import {
	IconButton,
	InputAdornment,
	Stack,
	styled,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import React, { FC, useState } from "react";
import { FormattedMessage } from "react-intl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export const TextFieldStack = styled(Stack)(() => ({
	alignItems: "flex-start",
	width: "100%",
}));

export const ErrorTypography = styled(Typography)(() => ({
	fontWeight: 400,
	fontSize: "16px",
	color: "red",
}));

export const SuccessTypography = styled(Typography)(() => ({
	fontWeight: 400,
	fontSize: "16px",
	color: "green",
}));

interface FormFieldValues {
	label: string;
	name: string;
	type?: string;
	value: string;
	autoComplete?: string;
	required?: boolean;
	disabled?: boolean;
	autoFocus?: boolean;
	handleChange: (e: React.ChangeEvent<any>) => void;
	handleBlur: (e: React.ChangeEvent<any>) => void;
	error: string | undefined;
	touched: boolean | undefined;
	tooltip?: string;
}

export const FormField: FC<FormFieldValues> = ({
	label,
	name,
	type = "text",
	value,
	autoComplete = name,
	required,
	disabled,
	autoFocus,
	handleChange,
	handleBlur,
	error,
	touched,
	tooltip,
}) => {
	const [showPassword, setShowPassword] = useState(false);

	return (
		<TextFieldStack spacing={1}>
			<Tooltip
				title={tooltip ?? ""}
				open={tooltip !== undefined && value === ""}
				placement="right-start"
				arrow
			>
				<Typography
					color="primary"
					fontFamily="Noto Sans Gujarati"
					fontWeight={700}
				>
					<FormattedMessage id={`field.${name}`} defaultMessage={label} />
					{required && <span> *</span>}
				</Typography>
			</Tooltip>
			<TextField
				fullWidth
				required={required}
				name={name}
				disabled={disabled}
				autoFocus={autoFocus}
				type={type === "password" ? (showPassword ? "text" : "password") : type}
				autoComplete={autoComplete}
				value={value}
				onChange={handleChange}
				onBlur={handleBlur}
				InputProps={
					type === "password"
						? {
								endAdornment: (
									<InputAdornment position="end">
										<IconButton
											onClick={() => setShowPassword((prev) => !prev)}
											size="small"
										>
											{showPassword ? (
												<VisibilityOff fontSize="small" />
											) : (
												<Visibility fontSize="small" />
											)}
										</IconButton>
									</InputAdornment>
								),
						  }
						: {}
				}
			/>
			{error && touched && <ErrorTypography>{error}</ErrorTypography>}
		</TextFieldStack>
	);
};
